module.exports = __webpack_public_path__ + "img/blue.844a6096.png";